import { Eye } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const EyeIcon = DeckardIconWrapper({ Icon: Eye });
